import AddToCartPopupState from "@DSG/Store/Pages/AddtoCartPopupState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialCounterState: AddToCartPopupState = { cartLine: undefined, showPopup:false };

const addToCartPopupStateImmerReducer = createTypedReducerWithImmer(initialCounterState, {
    "AddToCartPopup/Popup/Reset": (draft: Draft<AddToCartPopupState>) => {
        return initialCounterState;
    },
    "AddToCartPopup/Popup/ShowPopup": (draft: Draft<AddToCartPopupState>, action: { showPopup: boolean }) => {
        draft.showPopup = action.showPopup;
        return draft;
    },
    "AddToCartPopup/Popup/CartLine": (draft: Draft<AddToCartPopupState>, action: { cartLine: CartLineModel }) => {
        console.log("cartline1",action.cartLine)
        draft.cartLine = action.cartLine;
        return draft;
    },
});

// In the below code example, we have are injecting the our new reducer in existing predefined reducers object.

(reducers as any).addToCartPopUp = addToCartPopupStateImmerReducer;

type AddToCartPopupReducers = {
    addToCartPopUp: typeof addToCartPopupStateImmerReducer;
};

export type AddToCartPopupActions = Parameters<AddToCartPopupReducers[keyof AddToCartPopupReducers]>[1] | AnyAction;
